import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight, LucideIcon } from 'lucide-react'; // Importer LucideIcon pour typer l'icône

interface PricingInformationBlockProps {
  IconComponent: LucideIcon; // Accepter le composant Icône en prop
  iconColorClass: string; // Classe Tailwind pour la couleur de l'icône
  title: string;
  description: string;
  buttonText: string;
  cardClassName?: string; // Pour le style spécifique (gradient)
  onButtonClick: () => void;
}

const PricingInformationBlock: React.FC<PricingInformationBlockProps> = ({
  IconComponent,
  iconColorClass,
  title,
  description,
  buttonText,
  cardClassName = '',
  onButtonClick,
}) => {
  return (
    <Card className={cardClassName}>
      <CardHeader>
        <CardTitle className="flex items-center text-xl">
          <IconComponent className={`mr-2 h-5 w-5 ${iconColorClass}`} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground mb-4">
          {description}
        </p>
        <Button variant="outline" className="w-full mt-2" onClick={onButtonClick}>
          {buttonText}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default PricingInformationBlock; 